import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReportFeature } from 'src/app/interfaces/reports.interface';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'app-new-report',
  templateUrl: './new-report.component.html',
  styleUrls: ['./new-report.component.scss']
})
export class NewReportComponent implements OnInit {

  constructor(
    public modal: NgbActiveModal,
    public reportsService: ReportsService
  ) { }

  ngOnInit(): void {
  }

  onSelectFeature(feature: ReportFeature) {
    this.reportsService.selectedFeature = feature;
  }

}
